import { render, staticRenderFns } from "./HardwareDescription.vue?vue&type=template&id=0552e60b"
import script from "./HardwareDescription.vue?vue&type=script&lang=js"
export * from "./HardwareDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports